// Material UI
import { makeStyles } from '@material-ui/core'
// Consts
import Colors from './../../../constants/Colors'

export default makeStyles(theme => ({
  actionsContainer: {
    alignItems: 'center',
    borderTop: `1px solid ${Colors.DISABLED_COLOR}`,
    display: 'flex',
    justifyContent: 'space-between',
    padding: '24px 16px',
  },
  clearFilterButton: {
    color: Colors.SECONDARY_FONT_COLOR,
    fontSize: '13px !important',
    lineHeight: 'normal',
  },
  drawerBody: {
    overflow: 'inherit',
    padding: '24px',
  },
  drawerContent: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '100%',
    overflow: 'inherit',
  },
}))
